import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';
import { LossDto } from 'src/app/shared/dto/loss.dto';
import { BaseService } from 'src/app/shared/services/base.service';

@Injectable({
    providedIn: 'root',
})
export class MetricsService extends BaseService {

    constructor(httpClient: HttpClient) {
        super(httpClient, 'metrics');
    }

  getMetrics$(): Observable<any> {
    return this.httpClient.get<any>(`${this.url}/summary`);
  }
}